var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFullIcon = function SvgHeartFullIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.796 1.86A5.95 5.95 0 0 1 6.137 0a6 6 0 0 1 4.358 1.86l.002.002.496.524.471-.517.012-.012A6.07 6.07 0 0 1 15.846 0a6 6 0 0 1 4.357 1.858c2.396 2.464 2.396 6.45-.001 8.914l-8.828 9.07a.523.523 0 0 1-.748 0l-8.828-9.07C-.599 8.309-.599 4.324 1.796 1.86",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFullIcon;